import MDP from "../MDP";
import FFormMDP from "../form/FFormMDP";
import FDataTableMDP from "../table/FDataTableMDPbackup";


export default class FSearchGridMDP implements MDP {
  componentName = "FSearchGrid";

  gridMDP: FDataTableMDP;
  searchFormMDP: FFormMDP;
  myRefName: string;
  api: any;
  onSearch?: () => void;
  onClear?: () => void;
  title?: string;

  constructor(props: 
    {
    myRefName: string;
    gridMDP: FDataTableMDP;
    searchFormMDP: FFormMDP;
    api?:any;
    onSearch?: () => void;
    onClear?: () => void;
    title?: string;
 }) {
    this.myRefName = props.myRefName;
    this.searchFormMDP = props.searchFormMDP;
    this.gridMDP = props.gridMDP
    this.api = props.api;
    this.onSearch = props.onSearch;
    this.onClear = props.onClear;
    this.title = props.title;
  }


  getMetaData(): object {
    return {
      myRefName: this.myRefName,
      componentName: this.componentName,
      props: {
        myRefName: this.myRefName,
        gridMetaData: this.gridMDP.getMetaData(),
        searchFormMetaData: this.searchFormMDP.getMetaData(),
        api : this.api,
        onSearch: this.onSearch,
        onClear: this.onClear,
        title: this.title
      },
    };
  }

  
}

export class FSearchGridInput {
  searchCriteria: any;
  searchResultList: any[];

  constructor(searchCriteria: any={},searchResultList: any[]=[]) {
    this.searchCriteria = searchCriteria;
    this.searchResultList = searchResultList;
  }
}

